export class InformationFileViewModel {
    constructor(model) {
        this.model = model;
        this.isDelete = false;
    }
    model;
    get fileId() {
        return this.model.fileId;
    }
    get fileName() {
        return this.model.fileName;
    }
    isDelete;
}
